/**
 * A simple option of a select in a form.
 */
class FormFieldOption
{
	constructor(value, label)
	{
		this.value = value;
		this.label = label;
	}
}

export default FormFieldOption
